import React, {
  Fragment,
  useEffect, useState
} from 'react';

import Menu1 from "../Menu";
import Header from '../Header';
import Footer from '../Footer';
import { useNavigate, useLocation, Link } from "react-router-dom";
import {
  Form,Input,Row,Col,Select,message,Button,Switch,Icon,
} from 'antd';
import Cookie from 'js-cookie';
import { ApiGateWay } from '../../ApiGateWay/ApiGateWay';
import { Config } from '../../config/config';
import Spinner from '../../UIComponents/Spinner/Spinner';
import MessageBox from '../../UIComponents/MessageBox/MessageBox';
import { doGetVendorList, getSelectedVendorList, SaveVendorInfo, VendorList } from './actions/vendorService';
import { Space, Table, Typography, Modal } from 'antd';
import LZString from 'lz-string';
import { connect, useSelector, useDispatch } from "react-redux";


const { Option } = Select;

const VendorEdit = () => {
  const config = JSON.parse(Config);
  const apiInterface = config['api1'];
  const jsonData = Cookie.get('currentUser');
            let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
  const user = JSON.parse(decompressedData)
  const userID = user['userId'];
  // const [form] = Form.useForm();
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const vendor = useSelector(state => state?.vendorList?.VendorDetail);
  const vendorDetails = useSelector(state => state?.vendorList?.VendorDetails);
  const sup = useSelector(state=>state?.vendorList?.VendorDetail?.supplyDetail);
  const apiInfo = useSelector(state => state?.vendorList);
  const zoneList = vendorDetails?.ZoneList;
  const cityList = vendorDetails?.CityList;
  const stateList = vendorDetails?.StateList;
  const serviceList = vendorDetails?.ServiceList
  const [isSubmit, setIsSubmit] = useState(false);
  const [gstNumber, setGstNumber] = useState("s");
  const [thirdNumber, setThirdNumber] = useState("s");
  const [isAddSubmit, setIsAddSubmit] = useState(false)
  const [addExtraInfo, setAddExtraInfo] = useState([]);
  const [addInputField, setAddInputField] = useState({
    state_id: '',
    city_id: '',
    zone_id: '',
    third_number: '',
    gst_number: '',
    vendor_supply_row_id:0,
  });
  const doDelete = (i) => {
    const newArr = [...addExtraInfo];
    newArr.splice(i, 1)
    setAddExtraInfo(newArr)
  };
  // const addInfo = () => {
  //   setIsAddSubmit(true);
  //   if (addInputField.state_id == '') { return }
  //   else if (addInputField.zone_id == '') { return }
  //   else if (addInputField.city_id == '') { return }
  //   else if (addInputField.third_number == '') { return }
  //   else if (addInputField.gst_number == '') { return }
  //   setAddExtraInfo([...addExtraInfo, addInputField])
  //   setIsAddSubmit(false);
  //   setAddInputField({
  //     state_id: '',
  //     city_id: '',
  //     zone_id: '',
  //     third_number: '',
  //     gst_number: '',
  //     vendor_supply_row_id: 0,
  //   })
  // }
  const doEdit = (ele) => {
    if(ele.isEdit==true){
      ele.isEdit = false;
    }else{
      ele.isEdit = true; 
    }
    const newArr = [...form.vendor_supply_details];
    setState({ ...form, vendor_supply_details: newArr })
    console.log(ele,'newArr')
  }

  const [form, setState] = useState({
    created_by: userID,

    vendor_id: vendor?.id,
    vendor_code: vendor?.vendor_code,
    vendor_name: vendor?.vendor_name,
    vendor_address: vendor?.vendor_address,
    service_type: vendor?.service_field_type?.split(',').map(ele=>Number(ele)),
    contact_name1: vendor?.contact_name1,
    contact_name2: vendor?.contact_name2,
    mobile_number1: vendor?.mobile_number1,
    mobile_number2: vendor?.mobile_number2,
    designation1: vendor?.designation1,
    designation2: vendor?.designation2,
    email_address1: vendor?.email_address1,
    email_address2: vendor?.email_address2,
    vendor_active: true,
    vendor_supply_details: sup
  });
  const handleDropDown = (data, value, selectedField) => {
    if (selectedField == 'city') data.city = value;
    else if (selectedField == 'zone') data.zone = value;
    else if (selectedField == 'state') data.state = value;
    const newArr = [...form.vendor_supply_details];
    setState({ ...form, vendor_supply_details: newArr })
  }
  const handleInput=(data, value,inputName)=>{
    if(inputName=='gst'){
     setGstNumber(value);
    data.gst_number=value;
    }
    else if(inputName=='third'){
    setThirdNumber(value);
    data.third_number=value;
    }
    const newArr = [...form.vendor_supply_details];
    setState({ ...form, vendor_supply_details: newArr })
  }
  const designations = [
    {
      Label: "Associate",
      Value: "1",
    },
    {
      Label: "Team Lead",
      Value: "2",
    },
    {
      Label: "Technical Manager",
      Value: "3",
    }
  ]

  const validateEmail = (email) => {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  const addInfo = () => {
    setIsAddSubmit(true);
    if(addInputField.state_id==''){return}
    else if(addInputField.zone_id==''){return}
    else if(addInputField.city_id==''){return}
    else if(addInputField.third_number==''){return}
    else if(addInputField.gst_number==''){return}
    setAddExtraInfo([...addExtraInfo, addInputField])
    setIsAddSubmit(false);
    setAddInputField({
      state_id: '',
      city_id: '',
      zone_id: '',
      third_number: '',
      gst_number: '',
      vendor_supply_row_id:0,
    })
  }
// console.log(addExtraInfo,'addExtraInfo')
  const _doSubmit = () => {
    setIsSubmit(true);
    if (form?.vendor_code == '') return;
    else if (form.vendor_name?.trim() == '') return;
    else if (form.vendor_address?.trim() == '') return;
    else if (gstNumber?.trim() == '') return;
    else if (thirdNumber?.trim() == '') return;
    else if (form.service_type == '') return;
    else if (form.contact_name1?.trim() == '') return;
    else if ((`${form.mobile_number1}`.length < 10 || `${form.mobile_number1}`.length > 10)) return;
    else if (form.designation1 == '') return;
    else if (form.email_address1?.trim() == '' || !validateEmail(form.email_address1)) return;
    else if (form.contact_name2?.trim() == '') return;
    else if ((`${form.mobile_number2}`.length < 10 || `${form.mobile_number2}`.length > 10)) return;
    else if (form.designation2 == '') return;
    else if (form.email_address2?.trim() == '' || !validateEmail(form.email_address2)) return;
    form.vendor_active = form.vendor_active ? 1 : 0;
    form.service_type=form.service_type?.join();
    form.vendor_supply_details=tableData;
    console.log(tableData,'tableData')
    dispatch(SaveVendorInfo(form))
  }
  const [stateListData, setStateListData] = useState([])
  const [submitedData,setSubmitedData] = useState({
    city_id:'',
    state_id:'',
    gst_number:'',
    third_number:'',
    zone_id:'',
    vendor_supply_row_id:0,
  })
  const [tableData, setTableData] = useState([])
  const _doEdit = (record, index) =>{
    let info = {
      city_id:record.city_id,
      state_id:record.state_id,
      gst_number:record.gst_number,
      third_number:record.third_number,
      zone_id:record.zone_id,
      vendor_supply_row_id:record.vendor_supply_row_id
    }
    setSubmitedData(info);
    let data = [...tableData]
    let deleted = data.splice(index, 1);
    setTableData(data);
    let newStateList=[...stateListData];
    let fetchedData = stateList?.filter(ele=> ele.code_id == deleted[0].state_id).map(e=>newStateList.push(e))
    setStateListData(newStateList);
  }
  const _doDelete = (record,index) => {
    const newArr = [...tableData];
    let deletedData = newArr.splice(index, 1)
    let data =[...stateListData];
    if(deletedData.length !=0){
      let fetchedData = stateList?.filter(ele=> ele.code_id == deletedData[0]?.state_id).map(e=> data.push(e));
    }
    setStateListData(data);
    setTableData(newArr)
  };
  const  tableColumn= [
    {
    title: 'Action',
    dataIndex: 'action',
    key: 'action',
    render: (text, record,index) => {
        return (
        <Space size="middle">
            <div className="table-icons">
              {record.vendor_supply_row_id ==0 &&<i className="fa fa-trash-o text-danger" aria-hidden="true" onClick={()=>_doDelete(record,index)}/>}
              <i className="fa fa-pencil blue" aria-hidden="true" style={{cursor:submitedData.state_id!=''?'not-allowed':'pointer' }} onClick={()=>submitedData.state_id!=''?null:_doEdit(record,index)}/>
            </div>
        </Space>
        )
    }

    },
    {
      title: "Item Name",
      dataIndex: "State",
      key: "state_id",
      render:(text, record, index)=>{
        return(
          <Select className="form-control"
            value={record.state_id}
            disabled
          >{
              stateList.map((item =>
                <Option key={item.code_id} value={item.code_id}>{item.code_value}</Option>
              ))
            }
          </Select>
        )
      }
    },
    {
      title: "Zone",
      dataIndex: "zone_id",
      key: "zone_id",
      render: (text,record,index)=>{
        return(
        <Select className="form-control"
          value={record.zone_id}
          disabled
        >{
            zoneList?.map((item =>
              <Option key={item.code_id} value={item.code_id}>{item.code_value}</Option>
            ))
          }
        </Select>)
      }
    },
    {
      title: "City ",
      dataIndex: "city_id",
      key: "city_id",
      render: (text,record,index)=>{
        return(
        <Select className="form-control"
          value={record.city_id}
          disabled
        >{
          cityList.map((item =>
            <Option key={item.code_id} value={item.code_id}>{item.code_value}</Option>
          ))
          }
        </Select>)
      }

    },
    {
        title: "Third Number(Vendor Code)",
        dataIndex: "third_number",
        key: "third_number",
        render:(text,record,index)=>{
          return(<input disabled value={record.third_number}/>)
        }
    },
    {
        title: "GST Number*",
        dataIndex: "gst_number",
        key: "gst_number",
        render:(text,record,index)=>{
          return(<input disabled value={record.gst_number}/>)
        }
    },
  ]
const addTableData = () =>{
  setIsAddSubmit(true);
  if(submitedData.state_id==''){return}
  else if(submitedData.zone_id==''){return}
  else if(submitedData.city_id==''){return}
  else if(submitedData.third_number==''){return}
  else if(submitedData.gst_number==''){return}
  let data = [];
  let fetchedData =stateListData?.filter(ele=> ele.code_id != submitedData.state_id).map(e=>data.push(e))
  setStateListData(data);
  setTableData([...tableData,submitedData])
  setSubmitedData({
    city_id:'',
    state_id:'',
    gst_number:'',
    third_number:'',
    zone_id:'',
    vendor_supply_row_id:0,
  })
  setIsAddSubmit(false);
}
var deletedStateIds=[];
useEffect(()=>{
  let data = []
  sup?.forEach(ele=>{
    return(
      data.push(
      {city_id:ele.city_id,
      state_id:ele.state_id,
      gst_number:ele.gst_number,
      third_number:ele.third_number,
      zone_id:ele.zone_id,
      vendor_supply_row_id:ele.vendor_supply_row_id})
    )
  })
  setTableData(data)
  for(let i=0;i<sup?.length;i++){
    deletedStateIds.push(sup[i].state_id);
  }
},[sup])
useEffect(()=>{
    var toDelete = new Set(deletedStateIds);
    const newStateList = stateList?.filter(obj=> !toDelete.has(obj.code_id))
    setStateListData(newStateList);
},[stateList])
  return (
    <>
      <div>
        {apiInfo.modalOpen && !apiInfo?.loading ? (
          <MessageBox
            message={apiInfo.message}
            // signout={false}
            onClose={() => {
              if (apiInfo.apiStatus) {
                dispatch(VendorList(true))
                dispatch(doGetVendorList())
              }
            }
            }
          />
        ) : null}
        <Header title={"Create Vendor"} />
        <Menu1 />
        <div className='content-wrapper'>
          {apiInfo?.loading ? (
            <Spinner />
          ) : (
            <section className='content top-space'>
              <div className="m-panel">
                <div className="m-panel__body pb-10">
                  <div className="row m-grid">
                    <div className="col-md-4">
                      <div className="form-group">
                        <div className="form-group">
                          <label htmlFor='exampleInput'>Registration Number</label>
                          <input onChange={e => setState({ ...form, vendor_code: e.target.value.replace(/[^\w\s]/gi, "") })} type="text" maxLength="100" className="form-control"
                            value={form.vendor_code}
                            disabled
                          />
                          {form.vendor_code == '' && isSubmit ? <span className="text-danger">Please Enter Vendor Code</span> : null}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor='exampleInput'>Vendor name*</label>
                        <input type="text" maxLength="100" className="form-control" value={form.vendor_name} onChange={e => setState({ ...form, vendor_name: e.target.value.replace(/[^\w\s]/gi, "") })} />
                        {form.vendor_name?.trim() == '' && isSubmit ? <span className="text-danger">Please Enter Vendor Name</span> : null}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor='exampleInput' >Vendor address*</label>
                        <input type="text" maxLength="100" className="form-control" value={form.vendor_address} onChange={e => setState({ ...form, vendor_address: e.target.value.replace(/[^\w\s]/gi, "") })} />
                        {form.vendor_address?.trim() == '' && isSubmit ? <span className="text-danger">Please Enter Vendor Address</span> : null}
                      </div>
                    </div>
                    {/* <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor='exampleInput'>GST number*</label>
                        <input type="text" className="form-control" value={form.gst_number} onChange={e => setState({ ...form, gst_number: e.target.value })} />
                        {form.gst_number.trim() == '' && isSubmit ? <span className="text-danger">Please Enter Vendor Address</span> : null}

                      </div>
                    </div> */}
                    <div className="col-md-4">
                      <div className="form-group select_h150">
                        <label htmlFor='exampleInput'>Type of services*</label>
                        <Select className="form-control"
                          showSearch
                          mode="multiple"
                          onChange={(value) => setState({ ...form, service_type: value })}
                          value={form.service_type}
                          placeholder="-- Please Select --"
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          {
                            serviceList?.map((item =>
                              <Option key={item.id} value={item.id}>{item.name}</Option>
                            ))
                          }
                        </Select>
                        {(form.service_type == ''||form.service_type == undefined) && isSubmit ? <span className="text-danger">Please Select Service</span> : null}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className='form-group'>
                        <label htmlFor='exampleInput'>Vendor Status*</label>
                        <Switch checkedChildren="Active" onChange={(status) => setState({ ...form, vendor_active: status })} defaultChecked={form.vendor_active} />
                        {/* <Switch checkedChildren="Yes" unCheckedChildren="No" defaultChecked onChange={(status) => setStoreStatus(status)} /> */}
                        {/* {form.vendor_active.trim()=='' && isSubmit ? <span className="text-danger">Please Enter Vendor Address</span> : null} */}

                      </div>
                    </div>

                    <div className="col-md-12">
                      <h5 className="m-panel__subtitle">Service Available</h5>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor='exampleInput'>Contact name*</label>
                        <input type="text" maxLength="100" className="form-control" value={form.contact_name1} onChange={e => setState({ ...form, contact_name1: e.target.value.replace(/[^\w\s]/gi, "") })} />
                        {form.contact_name1?.trim() == '' && isSubmit ? <span className="text-danger">Please Enter Contact Name</span> : null}

                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor='exampleInput'>Mobile number*</label>
                        <input type="text" maxLength="10" className="form-control" value={form.mobile_number1} onChange={e => setState({ ...form, mobile_number1: e.target.value.replace(/[^0-9]/g, '') })} />
                        {(`${form.mobile_number1}`.length < 10 || `${form.mobile_number1}`.length > 10) && isSubmit ? <span className="text-danger">Please Enter Valid Mobile Number</span> : null}

                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className='form-group'>
                        <label htmlFor='exampleInput'>Designation*</label>
                        {/* <Select className="form-control"
                          showSearch
                          onChange={(value) => setState({ ...form, designation1: value })}
                          value={form.designation1}
                          // onChange={this._doSelectVender}
                          placeholder="-- Please Select --"
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          }
                        > {
                            designations.map((item =>
                              <Option key={item.Value} value={item.Value}>{item.Label}</Option>
                            ))
                          }
                        </Select> */}
                        <input type="text" maxLength="100" className="form-control" disabled value={form.designation1} onChange={e => setState({ ...form, designation1: e.target.value.replace(/[^\w\s]/gi, "") })} />
                        {form.designation1 == '' && isSubmit ? <span className="text-danger">Please Select Designation</span> : null}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor='exampleInput'>Email address*</label>
                        <input type="text" maxLength="100" className="form-control" value={form.email_address1} onChange={e => setState({ ...form, email_address1: e.target.value.replace(/[^a-zA-Z0-9_@. ]/gi,""), })} />
                        {(form.email_address1?.trim() == '' || !validateEmail(form.email_address1)) && isSubmit == true ? <span className="text-danger">Please Enter Valid Email ID</span> : null}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor='exampleInput'>Contact name*</label>
                        <input type="text" maxLength="100" className="form-control" value={form.contact_name2} onChange={e => setState({ ...form, contact_name2: e.target.value.replace(/[^\w\s]/gi, "") })} />
                        {form.contact_name2?.trim() == '' && isSubmit ? <span className="text-danger">Please Enter Contact Name</span> : null}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor='exampleInput'>Mobile number*</label>
                        <input type="text" maxLength="10" className="form-control" value={form.mobile_number2} onChange={e => setState({ ...form, mobile_number2: e.target.value.replace(/[^0-9]/g, '') })} />
                        {(`${form.mobile_number2}`.length < 10 || `${form.mobile_number2}`.length > 10) && isSubmit ? <span className="text-danger">Please Enter Valid Mobile Number</span> : null}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className='form-group'>
                        <label htmlFor='exampleInput'>Designation*</label>
                        {/* <Select className="form-control"
                          showSearch
                          onChange={(value) => setState({ ...form, designation2: value })}
                          value={form.designation2}
                          // onChange={this._doSelectVender}
                          placeholder="-- Please Select --"
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          }
                        > {
                            designations.map((item =>
                              <Option key={item.Value} value={item.Value}>{item.Label}</Option>
                            ))
                          }
                        </Select> */}
                        <input type="text" maxLength="100" className="form-control" value={form.designation2} onChange={e => setState({ ...form, designation2: e.target.value.replace(/[^\w\s]/gi, "") })} />
                        {form.designation2 == '' && isSubmit ? <span className="text-danger">Please Select Designation</span> : null}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor='exampleInput'>Email address*</label>
                        <input type="text" maxLength="100" className="form-control" value={form.email_address2} onChange={e => setState({ ...form, email_address2: e.target.value.replace(/[^a-zA-Z0-9_@. ]/gi,""), })} />
                        {(form.email_address2?.trim() == '' || !validateEmail(form.email_address2)) && isSubmit == true ? <span className="text-danger">Please Enter Valid Email ID</span> : null}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <h5 className="m-panel__subtitle">Add</h5>
                    </div>
                    {/* <div className="col-md-2">
                      <div className='form-group'>
                        <label htmlFor='exampleInput'>State*</label>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className='form-group'>
                        <label htmlFor='exampleInput'>Zone*</label>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className='form-group'>
                        <label htmlFor='exampleInput'>City*</label>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label htmlFor='exampleInput'>Third number(Vendor Code)*</label>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label htmlFor='exampleInput'>GST number*</label>
                      </div>
                    </div>
                    
                    {
                      sup?.map((ele, i) => {
                        return (
                          <Fragment key={i}>
                            <div className="col-md-2">
                              <div className="form-group">
                                <Select className="form-control"
                                  showSearch
                                  disabled={ele.isEdit}
                                  value={ele.state_id}
                                  onChange={(value) => handleDropDown(ele, value, 'state')}
                                  placeholder="-- Please Select --"
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                  }
                                > {
                                    stateList.map((item =>
                                      <Option key={item.code_id} value={item.code_id}>{item.code_value}</Option>
                                    ))
                                  }
                                </Select>
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-group">
                                <Select className="form-control"
                                  showSearch
                                  disabled={ele.isEdit}
                                  value={ele.zone_id}
                                  onChange={(value) => handleDropDown(ele, value, 'zone')}
                                  placeholder="-- Please Select --"
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                  }
                                > {
                                    zoneList?.map((item =>
                                      <Option key={item.code_id} value={item.code_id}>{item.code_value}</Option>
                                    ))
                                  }
                                </Select>
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-group">
                                <Select className="form-control"
                                  showSearch
                                  value={ele.city_id}
                                  disabled={ele.isEdit}
                                  onChange={(value) => handleDropDown(ele, value, 'city')}
                                  placeholder="-- Please Select --"
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                  }
                                > {
                                    cityList.map((item =>
                                      <Option key={item.code_id} value={item.code_id}>{item.code_value}</Option>
                                    ))
                                  }
                                </Select>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="form-group">
                              <input type="text" disabled={ele.isEdit} className="form-control" value={ele.third_number}  onChange={(e)=>handleInput(ele,e.target.value,'third')} />
                              {ele.third_number == '' && isSubmit ? <span className="text-danger">Please Enter Third Number</span> : null}
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-group">
                                <input type="text" className="form-control" disabled={ele.isEdit} value={ele.gst_number} onChange={(e)=>handleInput(ele,e.target.value,'gst')} />
                                {ele.gst_number == '' && isSubmit ? <span className="text-danger">Please Enter GST Number</span> : null}
                              </div>
                            </div>
                            <div className="col-md-1 form-group">
                              <div className="m-btn-block__icon">
                                <i className="fa fa-edit" aria-hidden="true" onClick={() => doEdit(ele)}></i>
                              </div>
                            </div>
                          </Fragment>
                        )
                      })
                    } */}
                  </div>
                  {/* <div className='row m-grid'>
                  {
                      addExtraInfo?.map((ele, i) => {
                        return (
                          <Fragment key={i}>
                            <div className="col-md-2">
                              <div className="form-group">
                                <Select className="form-control"
                                  showSearch
                                  disabled
                                  value={ele.state_id}
                                  // onChange={this._doSelectVender}
                                  placeholder="-- Please Select --"
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                  }
                                > {
                                    stateList.map((item =>
                                      <Option key={item.code_id} value={item.code_id}>{item.code_value}</Option>
                                    ))
                                  }
                                </Select>
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-group">
                                <Select className="form-control"
                                  showSearch
                                  disabled
                                  value={ele.zone_id}
                                  // onChange={this._doSelectVender}
                                  placeholder="-- Please Select --"
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                  }
                                > {
                                    zoneList.map((item =>
                                      <Option key={item.code_id} value={item.code_id}>{item.code_value}</Option>
                                    ))
                                  }
                                </Select>
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-group">
                                <Select className="form-control"
                                  showSearch
                                  disabled
                                  value={ele.city_id}
                                  // onChange={this._doSelectVender}
                                  placeholder="-- Please Select --"
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                  }
                                > {
                                    cityList.map((item =>
                                      <Option key={item.code_id} value={item.code_id}>{item.code_value}</Option>
                                    ))
                                  }
                                </Select>
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>{ele.third_number}</label>
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>{ele.gst_number}</label>
                              </div>
                            </div>
                            <div className="col-md-2 form-group--add">
                              <div className="m-btn-block__icon">
                                <i className="fa fa-trash-o" aria-hidden="true" onClick={() => doDelete(i)}></i>
                              </div>
                            </div>
                          </Fragment>
                        )
                      })
                  }

                  </div> */}
                  {/* <div className='row'>
                  <div className="col-md-2">
                      <div className='form-group'>
                        <label htmlFor='exampleInput'>State*</label>
                        <Select className="form-control"
                          onChange={(value) => setAddInputField({ ...addInputField, state_id: value })}
                          value={addInputField.state_id}
                          showSearch
                          placeholder="-- Please Select --"
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          }
                        >{
                            stateList.map((item =>

                              <Option key={item.code_id} value={item.code_id}>{item.code_value}</Option>
                            ))
                          }
                        </Select>
                        {addInputField.state_id == '' && isAddSubmit ? <span className="text-danger">Please Select State</span> : null}
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className='form-group'>
                        <label htmlFor='exampleInput'>Zone*</label>
                        <Select className="form-control"
                          onChange={(value) => setAddInputField({ ...addInputField, zone_id: value })}
                          value={addInputField.zone_id}
                          showSearch
                          placeholder="-- Please Select --"
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          }
                        >{
                            zoneList?.map((item =>

                              <Option key={item.code_id} value={item.code_id}>{item.code_value}</Option>
                            ))
                          }
                        </Select>
                        {addInputField.zone_id == '' && isAddSubmit ? <span className="text-danger">Please Select Zone</span> : null}
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className='form-group'>
                        <label htmlFor='exampleInput'>City*</label>
                        <Select className="form-control"
                          showSearch
                          onChange={(value) => setAddInputField({ ...addInputField, city_id: value })}
                          value={addInputField.city_id}
                          // onChange={this._doSelectVender}
                          placeholder="-- Please Select --"
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          }
                        > {
                            cityList.map((item =>
                              <Option key={item.code_id} value={item.code_id}>{item.code_value}</Option>
                            ))
                          }
                        </Select>
                        {addInputField.city_id == '' && isAddSubmit ? <span className="text-danger">Please Select City</span> : null}
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label htmlFor='exampleInput'>Third number(Vendor Code)*</label>
                        <input type="text" className="form-control" value={addInputField.third_number || ""} onChange={e => setAddInputField({ ...addInputField, third_number: e.target.value })} />
                        {addInputField.third_number == '' && isAddSubmit ? <span className="text-danger">Please Enter Third Number</span> : null}
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label htmlFor='exampleInput'>GST number*</label>
                        <input type="text" className="form-control" value={addInputField.gst_number || ""} onChange={e => setAddInputField({ ...addInputField, gst_number: e.target.value })} />
                        {addInputField.gst_number == '' && isAddSubmit ? <span className="text-danger">Please Enter GST Number</span> : null}
                      </div>
                    </div>
                    <div className="col-md-1 form-group--add">
                      <div className="m-btn-block__icon" onClick={addInfo}>
                        <i className="fa fa-plus-circle " aria-hidden="true" ></i>
                      </div>
                    </div>
                  </div> */}

                  
                  <div className='row'>
                  <div className="col-md-2">
                      <div className='form-group'>
                        <label htmlFor='exampleInput'>State*</label>
                        <Select className="form-control"
                          onChange={(value) => setSubmitedData({ ...submitedData, state_id: value })}
                          value={submitedData.state_id}
                          showSearch
                          placeholder="-- Please Select --"
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          }
                        >{
                          stateListData?.map((item =>

                              <Option key={item.code_id} value={item.code_id}>{item.code_value}</Option>
                            ))
                          }
                        </Select>
                        {submitedData.state_id == '' && isAddSubmit ? <span className="text-danger">Please Select State</span> : null}
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className='form-group'>
                        <label htmlFor='exampleInput'>Zone*</label>
                        <Select className="form-control"
                          onChange={(value) => setSubmitedData({ ...submitedData, zone_id: value })}
                          value={submitedData.zone_id}
                          showSearch
                          placeholder="-- Please Select --"
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          }
                        >{
                            zoneList?.map((item =>
                              <Option key={item.code_id} value={item.code_id}>{item.code_value}</Option>
                            ))
                          }
                        </Select>
                        {submitedData.zone_id == '' && isAddSubmit ? <span className="text-danger">Please Select Zone</span> : null}
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className='form-group'>
                        <label htmlFor='exampleInput'>City*</label>
                        <Select className="form-control"
                          showSearch
                          onChange={(value) => setSubmitedData({ ...submitedData, city_id: value })}
                          value={submitedData.city_id}
                          // onChange={this._doSelectVender}
                          placeholder="-- Please Select --"
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          }
                        > {
                            cityList?.map((item =>
                              <Option key={item.code_id} value={item.code_id}>{item.code_value}</Option>
                            ))
                          }
                        </Select>
                        {submitedData.city_id == '' && isAddSubmit ? <span className="text-danger">Please Select City</span> : null}
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label htmlFor='exampleInput'>Third number(Vendor Code)*</label>
                        <input type="text" maxLength="100" className="form-control" value={submitedData.third_number || ""} onChange={e => setSubmitedData({ ...submitedData, third_number: e.target.value.replace(/[^\w\s]/gi, "") })} />
                        {submitedData.third_number == '' && isAddSubmit ? <span className="text-danger">Please Enter Third Number</span> : null}
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label htmlFor='exampleInput'>GST number*</label>
                        <input type="text" maxLength="100" className="form-control" value={submitedData.gst_number || ""} onChange={e => setSubmitedData({ ...submitedData, gst_number: e.target.value.replace(/[^\w\s]/gi, "") })} />
                        {submitedData.gst_number == '' && isAddSubmit ? <span className="text-danger">Please Enter GST Number</span> : null}
                      </div>
                    </div>
                    <div className="col-md-1 form-group--add">
                      <div className="m-btn-block__icon" onClick={addTableData}>
                        <i className="fa fa-plus-circle " aria-hidden="true" ></i>
                      </div>
                    </div>
                  </div>

                  <Table filterSearch="true"
                    columns={tableColumn}
                    dataSource={tableData}
                  />
                  <div className="row">
                    <div className="col-md-12 text-right">
                      <div className="m-page__button top-space">
                        <button htmltype="submit" className='btn muted-button  deca-btn-yellow' onClick={_doSubmit}>Submit</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 text-right">
                  <div className="m-page__button top-space">
                  <Link className="option" to='/Vendors'>
                    <button type='button' className='btn muted-button  deca-btn-orange'  onClick={()=>dispatch(VendorList(true))}>Back</button>
                  </Link>
                  </div>
                </div>
              </div>
            </section>
          )}
        </div>

      </div>
    </>

  )
}

export default VendorEdit;
